export const BRAND_1_CONSTANTS = {
  // One brand "pill". Mobile image is optional — widget falls back to desktop image.
  DEFAULT_ROW: {
    id: "1",
    meta_image: "",
    meta_mobile_image: "",
    meta_alt_image: "",
    meta_priority: "1",
  },

  CARD_FIELDS_CONFIG: [],

  BRAND_FIELDS_CONFIG: [
    {
      fieldName: "desktop_background_color",
      label: "Desktop Background Color",
      value: "#000000",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Select desktop background color",
      required: false,
      defaultValue: "#000000",
    },
    {
      fieldName: "mobile_background_color",
      label: "Mobile Background Color",
      value: "#000000",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Select mobile background color",
      required: false,
      defaultValue: "#000000",
    },
    {
      fieldName: "backvariant",
      // Non-empty so a fresh create submits a valid ENUM (empty string truncates the ENUM column).
      label: "Background Variant",
      value: "variant_3",
      valueType: "string",
      filedType: "SELECT",
      placeholder: "Select background variant",
      required: false,
      defaultValue: "variant_3",
      options: [
        { label: "Variant 1 (Gradient)", value: "variant_1" },
        { label: "Variant 2 (Gradient)", value: "variant_2" },
        { label: "Variant 3 (Solid)", value: "variant_3" },
      ],
    },
    {
      fieldName: "gradient_color_1",
      label: "Gradient Color 1",
      value: "",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Select gradient color 1",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "gradient_color_2",
      label: "Gradient Color 2",
      value: "",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Select gradient color 2",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "gradient_color_3",
      label: "Gradient Color 3",
      value: "",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Select gradient color 3",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "gradient_color_4",
      label: "Gradient Color 4",
      value: "",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Select gradient color 4",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "font_style",
      label: "Font Style",
      value: "var(--font-google-sans)",
      valueType: "string",
      filedType: "SELECT",
      placeholder: "Select font style",
      required: false,
      defaultValue: "var(--font-google-sans)",
      options: [
        { label: "Google Sans", value: "var(--font-google-sans)" },
        { label: "Merriweather", value: "var(--font-merriweather)" },
        { label: "Circular Std", value: "var(--font-circular-std)" },
      ],
    },
    {
      fieldName: "pre_title",
      label: "Section Header (line 1)",
      value: "Solve real business challenges",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "e.g. Solve real business challenges (max 50 chars)",
      required: false,
      defaultValue: "Solve real business challenges",
    },
    {
      fieldName: "pre_title_color",
      label: "Section Header Color (line 1)",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Select section header color",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "title",
      label: "Section Header Highlight (line 2)",
      value: "for leading brands",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "e.g. for leading brands (max 50 chars)",
      required: false,
      defaultValue: "for leading brands",
    },
    {
      fieldName: "title_color",
      label: "Section Header Highlight Color (line 2)",
      value: "#02A7B6",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Select highlight color",
      required: false,
      defaultValue: "#02A7B6",
    },
    {
      fieldName: "description",
      label: "Description",
      value: "",
      valueType: "string",
      filedType: "TEXT_AREA",
      placeholder: "Enter description (max 200 chars)",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "description_color",
      label: "Description Color",
      value: "rgba(255,255,255,0.7)",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Select description color",
      required: false,
      defaultValue: "rgba(255,255,255,0.7)",
    },
    {
      fieldName: "enable_animation",
      label: "Enable Animation",
      value: "",
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Enable animation",
      required: false,
      defaultValue: false,
    },
    {
      fieldName: "status",
      label: "Status",
      value: "",
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Set status",
      required: false,
      defaultValue: false,
    },
  ],

  METADATA_FIELDS: [
    {
      header: "Desktop Image",
      fieldName: "meta_image",
      label: "Desktop Image",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload desktop brand logo",
      required: false,
      defaultValue: "",
    },
    {
      header: "Mobile Image",
      fieldName: "meta_mobile_image",
      label: "Mobile Image (optional)",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload mobile brand logo (falls back to desktop)",
      required: false,
      defaultValue: "",
    },
    {
      header: "Alt Image",
      fieldName: "meta_alt_image",
      label: "Alt Image",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter alt text for image",
      required: false,
      defaultValue: "",
    },
    {
      header: "Priority",
      fieldName: "meta_priority",
      label: "Priority",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter priority",
      required: false,
      defaultValue: "1",
    },
  ],
};

export default BRAND_1_CONSTANTS;
